<template>
    <v-card>
        
        <v-toolbar class="no-printable" color="primary" dark>
            
            <v-btn @click="$emit('hide')" icon>
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title></v-toolbar-title>
            <v-select
            width="100px"
            class="ml-5"
            :items="['Prime', 'Unibox']"
            v-model="societe"
            hide-details
            dense
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn text @click="newFicheCaisse = true">
                <v-icon>mdi-refresh</v-icon> Initialiser?
            </v-btn>
            <v-btn text @click="edit_">
                <v-icon>mdi-pencil</v-icon> Editer
            </v-btn>
            <v-btn text @click="print">
                <v-icon>mdi-printer</v-icon> Imprimer
            </v-btn>
        </v-toolbar>
        <v-snackbar
            class="no-printable"
            v-model="snackbar"
            :color="snackColor"
            left
            bottom
            
        >
            {{snackText}}
            <v-btn
            text
            dark
            @click="snackbar = false"
            >
            Fermer
            </v-btn>
        </v-snackbar>
        <div class="fullwidth" v-if="societe === 'Prime'">
            <div class="width-50">
                <div class="printable-content">
                    <img class="logo" src="https://i.imgur.com/J8CnA93.png" />
                </div>
            </div>
            <div class="width-50">
                <div class="printable-content">
                    <div class="info-text">
                        <b>Prime Shipping Agency </b><br/>
                        Rue de l'exportation Zone Industrielle rades 2040 <br/>
                        Ben Arous Tunisie. Tél. : +216 71 461 699  <br/>
                        Email : safa.masri@primeshipping.tn <br/>
                    </div>
                </div>
            </div>
        </div>
        <div class="fullwidth" v-if="societe === 'Unibox'">
            <div class="width-50">
                <div class="printable-content">
                    <img class="logo" src="https://i.imgur.com/LBw0phu.jpg" />
                </div>
            </div>
            <div class="width-50">
                <div class="printable-content">
                    <div class="info-text">
                        Unibox Express Delivery<br/>
                        Rue de l'exportation Zone Industrielle rades 2040 <br/>
                        Ben Arous Tunisie. Tél. : +216 71 461 699  <br/>
                        Email : safa.masri@unibox.tn <br/>
                    </div>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="fullwidth">
            <div class="printable-content">
                <h3>Fiche de Caisse N°{{currentFicheCaisse.num_fiche_caisse}}</h3>
            </div>
        </div>
        <div class="fullwidth only-print">
                <div class="width-50">
                    <div class="printable-content m-t-0 p-t-0 p-b-0 m-t-0">
                        <div class="width-50">
                            <span class="client-label">Date : {{new Date() | formatDate}} </span>
                        </div>
                        <div class="width-50" v-if="currentDossier">
                            <span class="client-label">Dossier N° : {{currentDossier.numdossier}} </span>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="width-33">
                    <div class="fullwidth">
                        <div class="printable-content m-t-0 p-t-0">
                            <div class="coordonnee-client" v-if="currentAvis.client">
                                <p class="text-line"><b>{{currentAvis.client.fullname}}</b></p>
                                <p class="text-line">Ref#{{currentAvis.client.code_client}}</p>
                                <p class="text-line">{{currentAvis.client.adresse}}</p>
                                <p class="text-line">{{currentAvis.client.region}} - {{currentAvis.client.code_postal}}</p>
                                <p class="text-line">Tel : {{currentAvis.client.tel}} <span v-if="currentAvis.client.fax">- Fax : {{currentAvis.client.fax}}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="width-33">
                    <div class="fullwidth">
                        <div class="printable-content m-t-0 p-t-0">
                            <div class="coordonnee-client">
                                <div class="facture-data">
                                    <div class="facture-data-row">
                                            <div class="data-label">B/L N°</div>
                                            <div class="data-value">{{currentAvis.bl}}</div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="facture-data-row">
                                        <div><div class="data-label">Navire</div><div class="data-value">{{currentDossier.navire}}</div></div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="facture-data-row">
                                        <div><div class="data-label">Embarquement</div><div class="data-value">{{currentDossier.port_from_name}}</div></div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="facture-data-row">
                                        <div><div class="data-label">Débarquement</div><div class="data-value">{{currentDossier.port_to_name}}</div></div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="facture-data-row">
                                        <div><div class="data-label">Arrivée Le</div><div class="data-value">{{currentDossier.to_date | formatDate}}</div></div>
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="width-33">
                    <div class="fullwidth">
                        <div class="printable-content m-t-0 p-t-0">
                            <div class="coordonnee-client">
                                <div class="facture-data">
                                    <div class="facture-data-row">
                                            <div class="data-label">Facture B/L Relatif N°</div>
                                            <div class="data-value">{{currentFacture.num_facture}}</div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="facture-data-row">
                                        <div><div class="data-label">Fournisseur</div><div class="data-value">{{currentAvis.fournisseur}}</div></div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="facture-data-row">
                                        <div>
                                            <div class="data-label">P/C</div>
                                            <div class="data-value" v-if="currentAvis.pc.length > 1">{{currentAvis.pc}}</div>
                                            <div class="data-value" v-else>-</div>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="facture-data-row">
                                        <div><div class="data-label">Terme</div><div class="data-value">{{currentAvis.terme}}</div></div>
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="printable-content m-t-0 p-t-0 m-t-0">
                    <div class="width-50">
                        <span class="client-label">Devise : {{currentFacture.devise}} </span>
                    </div>
                    <div class="width-50">
                        <span class="client-label">Cours : {{currentFacture.cours}} </span>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="printable-content p-t-0 m-t-0">
                    <table border=0 class="table-print" width="100%">
                        <tr class="heading">
                            <td>Cont.Numéro</td>
                            <td>Cont.Type</td>
                            <td>Désignation Marchandises</td>
                            <td>Caution</td>
                        </tr>
                        <tr v-for="marchandise in currentFicheCaisse.marchandises" class="border-bottom-1" v-bind:key="marchandise.id">
                            <td>{{marchandise.cont_numero}}</td>
                            <td>{{marchandise.cont_type}}</td>
                            <td>{{marchandise.description}}</td>
                            <td>{{Number(marchandise.caution).toFixed(3)}}</td>
                        </tr>
                    </table>
                </div>
                
        </div>
        <v-card-text class="no-printable">
            <v-row class="data-fiche-caisse">
                <v-col md="3" class="text-left">Date : {{new Date() | formatDate}}</v-col>
                <v-col md="3" class="text-left">Client : {{currentAvis.client.fullname}} Ref#{{currentAvis.client.code_client}}</v-col>
                <v-col md="3" class="text-left">Dossier N°{{currentDossier.numdossier}}</v-col>
                <v-col md="3" class="text-left">Navire :  {{currentDossier.navire}}</v-col>
                <v-col md="3" class="text-left">Embarquement :  {{currentDossier.port_from_name}}</v-col>
                <v-col md="3" class="text-left">Débarquement :  {{currentDossier.port_to_name}}</v-col>
                <v-col md="3" class="text-left">B/L N° : {{currentAvis.bl}}</v-col>
                <v-col md="3" class="text-left">Facture B/L Relatif N°{{currentFacture.num_facture}} - Total : {{Number(currentFacture.montantTotal).toFixed(3)}}</v-col>
                <v-col md="3" class="text-left">Devise : {{currentFacture.devise}}</v-col>
                <v-col md="3" class="text-left">Cours : {{currentFacture.cours}}</v-col>
            </v-row>
            
            <v-data-table
                :headers="headers"
                :items="currentFicheCaisse.marchandises"
                :items-per-page="100"
                hide-default-footer
            >
                <template v-slot:[`item.caution`]="{ item }">
                    <v-text-field v-if="edit" outlined dense hide-details v-model="item.caution"></v-text-field>
                    <v-text-field v-else disabled outlined dense hide-details v-model="item.caution"></v-text-field>
                </template>
            </v-data-table>
        </v-card-text>
        
        <v-tooltip v-if="edit" left>
            <template v-slot:activator="{ on, attrs }">
                <v-fab-transition>
                <v-btn
                style="float:right;"
                    :color="`primary`"
                    fab
                    large
                    dark
                    bottom
                    @click="edit_"
                    right
                    v-bind="attrs"
                    v-on="on"
                    class="v-btn--example mr-5"
                >
                    <v-icon> mdi-pencil</v-icon>
                </v-btn>
                </v-fab-transition>
            </template>
            <span>Editer</span>
        </v-tooltip>
        
        <v-card-actions class="text-right">
            <v-spacer></v-spacer>
        </v-card-actions>
        <v-overlay v-model="newFicheCaisse">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
    </v-card>
</template>
<script>
import Printd from 'printd'
export default {
    name: 'single-fiche-caisse',
    props: ['currentAvis', 'currentDossier'],
    data: () => ({
        currentFicheCaisse : {},
        newFicheCaisse : false,
        currentFacture : {},
        edit: false,
        cssText: `
            @import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');
            .uppercase{
                text-transform: capitalize;
            }
            .p-0{
                padding:0 !important;
            }
            .assiette, .assiette td {
                border-collapse: collapse;
                border-radius: 10px;
            }
            .assiette td{
                border: 1px solid gray;
            }
            .p-t-0{
                padding-top:0px !important;
            }
            .m-t-0{
                margin-top:0px !important;
            }
            .p-b-0{
                padding-bottom:0px !important;
            }
            .m-b-0{
                margin-bottom:0px !important;
            }
            .line {
                width: 95%;
                height:2px;
                border-bottom: 1px solid gray;
                margin: 0 auto;
                display: block;
            }
            .total p{
                font-size:10px;
                padding: 2px;
            }
            .total{
                padding: 10px;
                border: 1px solid gray;
                margin-left: 20px;
                margin-bottom:10px;
            }
            *{
                margin:0;
                font-family: "Montserrat",sans-serif;
                outline: none;
            }
            .right {
                text-align:right;
            }
            .no-printable {
                display:none;
            }
            .fullwidth{
                width:100%;
            }
            .width-50{
                width:50% !important;
                float:left;
            }
            .width-75{
                width:75% !important;
                float:left;
            }
            .width-33{
                width: 33% !important;
                float:left;
            }
            .width-25{
                width:25% important;
                float:left;
            }
            .printable-content{
                margin: 8px;
                padding:15px;
            }
            .logo {
                width:170px;
            }
            .info-text {
                font-size:12px !important;
                line-height:14px;
                font-weight:400 !important;
                letter-spacing:1.2px;
                color: #000;
            }
            .clearfix{
                clear:both;
            }
            .client-label{
                font-size:10px;
            }
            .coordonnee-client{
                border: 0px solid gray;
                padding:15px;
            }
            .p-t-1{
                padding-top: 15px;
            }
            .text-line{
                font-size:12px;
                font-weight:normal;
            }
            .text-line.small{
                font-size:9px !important;
                color: rgba(0,0,0,0.2)
            }
            .table-print{
                border-collapse: collapse;
            }
            .table-print td{
                padding:2px 4px;
                font-size:10px;
            }
            .table-print-reglement td{
                padding:1px 2px;
                font-size:8px;
            }
            .table-print-reglement .heading td{
                background-color: #367fc3 !important;
                color: white !important;
                padding: 5px 3px !important;
                font-weight: 700 !important;
            }
            .table-print, .table-print td{
                border: 0px solid gray;
            }
            .table-print .heading td{
                background-color: #367fc3 !important;
                color: white !important;
                padding: 7px 5px !important;
                font-weight: 700 !important;
            }
            .table-print  td{
                padding: 7px 5px;
            }
            .footer-data{
                font-size:10px;
                line-height:18px;
                letter-spacing:1.2px;
            }
            .data-dossier .single-data{
                width:33%;
                float:left;
                font-size:9px;
                margin-top:5px;
                height: 18px;
            }
            .info-bar{
                font-size: 12px;
            }
            .facture-data-row .data-value{
                float:left;
                text-align: left;
                font-size:10px;
                line-height:15px;
            }
            .facture-data-row .data-label{
                float:left;
                text-align: left;
                color: black !important;
                font-size:10px;
                padding-right:5px;
                line-height:15px;
            }
            .width-66{
                width:66% !important;
                float:left;
            }
            .border-bottom-1 td{
                border-bottom:1px solid gray;
            }
            .border-1 {
                border:1px solid gray;
                border-radius:15px;
            }
            `,
        societe: 'Prime',
        snackbar: false,
        snackColor: 'error',
        snackText: 'text',
        ficheCaisseNumber: null,
        headers: [
            {value: 'cont_numero', text: 'N°Conteneur', width: 250},
            {value: 'cont_type', text: 'Type Conteneur'},
            {value: 'description', text: 'Description Marchandise'},
            {value: 'caution', text: 'Caution', width: 250}
        ]
    }),
    watch: {
        newFicheCaisse : function(){
            if(this.newFicheCaisse === true){
                this.initFicheCaisse()
            }
        }
    },
    mounted() {
        var facture = this.currentAvis.facture.filter(obj => { return obj.is_da === 0 && obj.is_magasinage === 0 && obj.is_surestarie === 0 && obj.avis_id > 0})
        console.log(facture)
        if(facture.length > 0){
            this.currentFacture = facture[0]
        }else{
            this.$router.push({name: 'singleFolder', params: {id: this.currentAvis.dossier_id }}).catch(err => {console.log(err)})
        }
        this.reloadData()
    },
    methods: {
        edit_(){
            this.edit = !this.edit
            
            /*this.snackColor = 'primary'
            this.snackText = 'Veuillez recliquer sur le bouton "Editer" pour sauvgarder les modifications.'
            this.snackbar = true*/
            if(this.edit === false){
                let data = {}
                data.marchandises = this.currentFicheCaisse.marchandises
                data.fiche_id = this.currentFicheCaisse.id
                this.editFicheCaisse(data)
                
                this.snackColor = 'success'
                this.snackText = 'Fiche de caisse modifiée avec succès.'
                this.snackbar = true
            }
        },
        initFicheCaisse(){
            this.axios
                .get('/fiche_caisse/listing')
                .then(response => { 
                    this.ficheCaisseNumber = this.setFicheCaisseNumber(response.data)
                    this.currentAvis.marchandises.forEach((item, key) => {
                        if(item.cont_type === 'SM'){
                            this.currentAvis.marchandises.splice(key, 1)
                        }
                    })
                    var data = {
                        marchandises: this.currentAvis.marchandises,
                        num_fiche_caisse: this.ficheCaisseNumber
                    }
                    this.axios
                        .post('/avis/'+this.currentAvis.id+'/fiche_caisse/init', data)
                        .then(response => {
                            this.reloadData()
                        })
                })
        },
        setFicheCaisseNumber(data){
            if(data.length > 0){
                var nextCode = data.reduce((max, p) => Number(p.num_fiche_caisse.slice(2, 10)) > max ? Number(p.num_fiche_caisse.slice(2, 10)) : max, data[0].num_fiche_caisse.slice(2,10))
                
                nextCode = nextCode.toString()
                if(Number(nextCode.slice(0, 4)) === new Date().getFullYear() ) {
                    nextCode = Number(nextCode)+1;
                    nextCode = 'FC'+nextCode
                }else{
                    nextCode = 'FC'+new Date().getFullYear()+'0001'
                }
                return nextCode
            }else{
                return 'FC'+new Date().getFullYear()+'0001'
            }
        },
        editFicheCaisse(data){
            this.axios
                .post('/fiche_caisse/'+data.fiche_id+'/update', data)
                .then(res => {
                    //console.log(res)
                })
        },
        print(){
            this.d = new Printd()
            this.d.print( this.$el, [this.cssText])
        },
        async reloadData(){
            await this.axios
                .get('/avis/'+this.currentAvis.id+'/fiche_caisse')
                .then(response => {
                    if(response.data.length > 0){
                        if(response.data[0].marchandises){
                            response.data[0].marchandises.forEach( (item, key) => {
                                this.axios
                                    .get('/conteneur/listing')
                                    .then(res => {
                                        res.data.forEach((itemCont, k) => {
                                            if(itemCont.id === item.cont_type_id){
                                                response.data[0].marchandises[key].cont_type = itemCont.titre
                                            }
                                        })
                                        if(response.data[0].marchandises.length === key+1){
                                            this.currentFicheCaisse = response.data[0]
                                        }
                                    })
                                
                            })                            
                        }
                        //this.currentFicheCaisse = response.data[0]
                        this.newFicheCaisse = false
                    }else{
                        this.newFicheCaisse = true   
                    }
                })
        }
    }
}
</script>
<style lang="scss" scoped>
.action-btn {
    background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); 
    box-shadow:0 0 20px rgba(0,0,0,0.2); 
    color: white; 
    border-radius:5px;
}
.facture-data-row .data-value{
    text-align: left;
}
.facture-data-row .data-label{
    text-align: right;
    padding-right: 35px;
    color: rgba(0,0,0,0.4);
}
.only-print{
    display: none;
}
.width-66{
    width:66% !important;
    float:left;
}
.line {
    width: 97%;
    height:1px;
    margin: 0 auto;
    display: block;
    background: rgba(0,0,0,0.1);
}
.total p{
    padding: 2px;
}
.total{
    padding: 10px;
    border: 1px solid rgba(0,0,0,0.2);
    margin-left: 20px;
    margin-bottom:10px;
}
div {
    text-align:left;
}
.logo {
    width:170px;
}
.right {
    text-align:right;
}
.printable-content{
    margin: 8px;
    padding:15px;
}
.fullwidth{
    width:100%;
}
.width-50{
    width:50% !important;
    float:left;
}
.width-33{
    width:33% !important;
    float:left;
}
.width-75{
    width:75% !important;
    float:left;
}
.width-25{
    width:25% !important;
    float:left;
}
.info-text {
    font-size:14px !important;
    line-height:20px;
    font-weight:400 !important;
    letter-spacing:1.2px;
    color: #000;
}
.clearfix{
    clear:both;
}
.client-label{
    font-size:12px;
}
.coordonnee-client{
    border: 0px solid rgba(0,0,0,0.2);
    padding:15px;
    margin: 5px;
}
.text-line{
    font-size:12px;
    font-weight:normal;
}
.table-print{
    border-collapse: collapse;
}
.table-print td{
    padding:5px 7px;
}
.table-print, .table-print td{
    border: 0px solid rgba(0,0,0,0.2);
}
.table-print .heading td{
    background: #367fc3;
    color: white;
    padding: 15px 10px;
    font-weight: 700;
}
.footer-data{
    font-size:13px;
    line-height:20px;
    letter-spacing:1.5px;
}
.data-dossier .single-data{
    width:33%;
    height: 50px;
    float:left;
}
.border-bottom-1 td{
    border-bottom:1px solid rgba(0,0,0,0.2)
}
.data-fiche-caisse{
    font-size:14px;
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/dossier/fiche_caisse/single.component.vue